export default __webpack_public_path__ + "static/media/star_review.fe0e751c.svg";